import styles from './Header2.module.css';
import * as React from 'react';


import Logo from "../images/usalco-logo-horizontal-2color-light.svg";
import LogoSmall from "../images/usalco-symbol-purple200.svg";
import RossLogo from "../images/aptean logo.png";
import RossLogoPurple from "../images/aptean logo purple.png";
import RossPlayLogo from "../images/aptean play.png";
import RossPlayLogoPurple from "../images/aptean play purple.png";
import HelpIcon from "../images/Help Icon.png";
import HelpIconPurple from "../images/Help Icon purple.png";
import Sharepoint from "../images/sharepoint.png";
import SharepointPurple from "../images/sharepoint purple.png";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from "@mui/material/Box";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Drawer,
    Stack,
    Tab,
    Tabs,
    Tooltip,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import ReactMarkdown from "react-markdown";

import SearchIcon from '@mui/icons-material/Search';

import {alpha, styled} from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";

import NavList from "./NavList";
import axios from "axios";

import { UserContext } from "../App.js";
import {
    useEffect
} from "react";

import { ChatSessionContext } from "../ai/ChatSessionProvider";
import ChatPanel from "../ai/ChatPanel";
import { computeAiEnabled } from "../ai/constants";


const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    textAlign: 'left',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 8px 18px rgba(38, 42, 86, 0.08)",
    '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
    marginLeft: 0,
    width: '100%',
    maxWidth: '300px'
}));
const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.secondary,
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        fontSize: 14,
    },
}));

function readmeNormalizeHeadingText(text) {
    let cleaned = text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
    cleaned = cleaned.replace(/`([^`]+)`/g, '$1');
    cleaned = cleaned.replace(/[*_~]/g, '');
    cleaned = cleaned.replace(/\s+#+\s*$/, '');
    return cleaned.trim();
}

function readmeBuildSlug(text, counts) {
    const base = text
        .toLowerCase()
        .replace(/[`*_~]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    const safe = base || 'section';
    const count = counts[safe] || 0;
    counts[safe] = count + 1;
    return count ? `${safe}-${count}` : safe;
}

function readmeExtractText(children) {
    if (children === null || children === undefined) return '';
    if (typeof children === 'string' || typeof children === 'number') return String(children);
    if (Array.isArray(children)) return children.map(readmeExtractText).join('');
    if (React.isValidElement(children)) return readmeExtractText(children.props?.children);
    return '';
}

export default function Header2(props){
    const userContext = React.useContext(UserContext);
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('md'));

    // AI chat. Only shown when the containing page opts in via catalystEnabled
    // (reports pass their re_include_in_ai value: 0=No, 1=Yes, 2=Admin only; other
    // pages pass a boolean). Gated on a security GUID unless the demo bypass flag is set.
    const chatSession = React.useContext(ChatSessionContext);
    const aiEnabled = React.useMemo(
        () => computeAiEnabled(props.catalystEnabled, userContext?.securities),
        [props.catalystEnabled, userContext?.securities]
    );

    const [chatWidth, setChatWidth] = React.useState(420);
    const isResizingChat = React.useRef(false);

    React.useEffect(() => {
        const onMouseMove = (e) => {
            if (!isResizingChat.current) return;
            const newWidth = window.innerWidth - e.clientX;
            const maxWidth = window.innerWidth > 1200
                ? Math.round(window.innerWidth * 0.75)
                : Math.round(window.innerWidth * 0.90);
            setChatWidth(Math.max(300, Math.min(maxWidth, newWidth)));
        };
        const onMouseUp = () => { isResizingChat.current = false; };
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
        return () => {
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };
    }, []);

    const sidebarStorageKey = 'reservoir.sidebarOpen';
    const [openPopper, setOpenPopper] = React.useState(false);
    const [sidebarOpen, setSidebarOpen] = React.useState(() => {
        try {
            const stored = localStorage.getItem(sidebarStorageKey);
            if (stored === 'true' || stored === 'false') return stored === 'true';
        } catch {}
        return mobile || props.pageName === 'Transportation Documents' ? false : true;
    });
    const [readmeOpen, setReadmeOpen] = React.useState(false);
    const [readmeTabIndex, setReadmeTabIndex] = React.useState(0);
    const [readmeCache, setReadmeCache] = React.useState({});
    const [readmeLoadingByUrl, setReadmeLoadingByUrl] = React.useState({});
    const [readmeErrorByUrl, setReadmeErrorByUrl] = React.useState({});
    const readmeHeadingCountsRef = React.useRef({});
    const [searchTerm, setSearchTerm] = React.useState('');
    const [searchResults, setSearchResults] = React.useState({});

    const readmeTabs = React.useMemo(() => {
        const hasSecurity = (securityGuid) => {
            if (!securityGuid) return true;
            if (!Array.isArray(userContext?.securities)) return false;
            return userContext.securities.some((s) => s.ua_fid === securityGuid);
        };

        if (Array.isArray(props.readmeTabs) && props.readmeTabs.length) {
            return props.readmeTabs.filter((tab) => tab && tab.url && hasSecurity(tab.securityGuid));
        }
        if (props.readmeUrl) {
            return [{ title: props.readmeTitle || "Help", url: props.readmeUrl }];
        }
        return [];
    }, [props.readmeTabs, props.readmeTitle, props.readmeUrl, userContext?.securities]);

    const readmeTabsKey = React.useMemo(
        () => readmeTabs.map((tab) => `${tab.title || ""}|${tab.url || ""}`).join("||"),
        [readmeTabs]
    );

    const activeReadme = readmeTabs[readmeTabIndex] || readmeTabs[0] || null;
    const rightAlignedReadmeIndex = readmeTabs.findIndex((tab) => tab.align === "right");
    const activeReadmeUrl = activeReadme?.url || '';
    const activeReadmeText = activeReadmeUrl ? (readmeCache[activeReadmeUrl] || '') : '';
    const activeReadmeError = activeReadmeUrl ? (readmeErrorByUrl[activeReadmeUrl] || '') : '';
    const activeReadmeLoading = activeReadmeUrl ? !!readmeLoadingByUrl[activeReadmeUrl] : false;

    //open / close the sidebar
    const menuIconClicked = ((args) => {
        setSidebarOpen((prev) => {
            const next = !prev;
            try {
                localStorage.setItem(sidebarStorageKey, next ? 'true' : 'false');
            } catch {}
            return next;
        });
    });

    const handleClick = () => {
        setOpenPopper(true);
    };
    const handleCloseSearch = () => {
        setSearchResults({});
        setSearchTerm('');
        setOpenPopper(false);
    };


    const onSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };
    const searchSubmit = (e) => {
        e.preventDefault();
        if(searchTerm === ''){
            handleCloseSearch();
        }else{
            search();
        }
    };
    const search = () => {
        axios.post(window.config.API_URL+'/search', {
            searchTerm: searchTerm
        },{})
             .then(response => {
                 console.log(response.data);
                 setSearchResults(response.data);
             })
             .catch(error => {
                 console.log('error', error);
                 alert(error.response.statusText);
             });
    };

    const signOut = (event) => {
        axios.post(window.config.API_URL+'user/sign_out', {}, { withCredentials: true })
            .then(response => {
                window.location.reload();
            })
            .catch(error => {
                console.log(error);
                alert('There was an issue while signing you out.');
            });
    };

    const loadReadme = async (url) => {
        if (!url || readmeCache[url] || readmeLoadingByUrl[url]) return;
        setReadmeLoadingByUrl((prev) => ({ ...prev, [url]: true }));
        setReadmeErrorByUrl((prev) => ({ ...prev, [url]: '' }));
        try {
            const res = await fetch(url);
            if (!res.ok) throw new Error('Readme not found');
            const text = await res.text();
            setReadmeCache((prev) => ({ ...prev, [url]: text }));
        } catch {
            setReadmeErrorByUrl((prev) => ({ ...prev, [url]: 'Unable to load the readme.' }));
        } finally {
            setReadmeLoadingByUrl((prev) => ({ ...prev, [url]: false }));
        }
    };

    const openReadme = () => {
        if (!readmeTabs.length) return;
        setReadmeOpen(true);
        if (activeReadmeUrl) loadReadme(activeReadmeUrl);
    };

    const closeReadme = () => {
        setReadmeOpen(false);
    };

    const handleReadmeTabChange = (event, nextIndex) => {
        setReadmeTabIndex(nextIndex);
        const nextUrl = readmeTabs[nextIndex]?.url;
        if (nextUrl) loadReadme(nextUrl);
    };

    useEffect(() => {
            document.title = "The Reservoir";
    }, []);

    useEffect(() => {
        setReadmeOpen(false);
        setReadmeTabIndex(0);
        setReadmeCache({});
        setReadmeLoadingByUrl({});
        setReadmeErrorByUrl({});
        readmeHeadingCountsRef.current = {};
    }, [readmeTabsKey]);

    useEffect(() => {
        if (readmeOpen) {
            readmeHeadingCountsRef.current = {};
        }
    }, [readmeOpen, readmeTabIndex, activeReadmeUrl]);

    const readmeHeadings = React.useMemo(() => {
        if (!activeReadmeText) return [];
        const counts = {};
        const headings = [];
        let inCodeBlock = false;
        activeReadmeText.split(/\r?\n/).forEach((line) => {
            if (/^```/.test(line.trim())) {
                inCodeBlock = !inCodeBlock;
                return;
            }
            if (inCodeBlock) return;
            const match = /^(#{1,6})\s+(.+)$/.exec(line);
            if (!match) return;
            const level = match[1].length;
            const cleaned = readmeNormalizeHeadingText(match[2] || '');
            if (!cleaned) return;
            headings.push({
                level,
                text: cleaned,
                slug: readmeBuildSlug(cleaned, counts),
            });
        });
        return headings;
    }, [activeReadmeText]);

    const readmeTocItems = readmeHeadings.filter((h) => h.level <= 4);

    const readmeComponents = React.useMemo(() => ({
        h1: (props) => {
            const text = readmeNormalizeHeadingText(readmeExtractText(props.children));
            const id = readmeBuildSlug(text, readmeHeadingCountsRef.current);
            return (
                <h1 {...props} id={id} style={{ ...props.style, scrollMarginTop: "12px" }}>
                    {props.children}
                </h1>
            );
        },
        h2: (props) => {
            const text = readmeNormalizeHeadingText(readmeExtractText(props.children));
            const id = readmeBuildSlug(text, readmeHeadingCountsRef.current);
            return (
                <h2 {...props} id={id} style={{ ...props.style, scrollMarginTop: "12px" }}>
                    {props.children}
                </h2>
            );
        },
        h3: (props) => {
            const text = readmeNormalizeHeadingText(readmeExtractText(props.children));
            const id = readmeBuildSlug(text, readmeHeadingCountsRef.current);
            return (
                <h3 {...props} id={id} style={{ ...props.style, scrollMarginTop: "12px" }}>
                    {props.children}
                </h3>
            );
        },
        h4: (props) => {
            const text = readmeNormalizeHeadingText(readmeExtractText(props.children));
            const id = readmeBuildSlug(text, readmeHeadingCountsRef.current);
            return (
                <h4 {...props} id={id} style={{ ...props.style, scrollMarginTop: "12px" }}>
                    {props.children}
                </h4>
            );
        },
    }), []);

    return (
        <div className={styles.pageContainer}>
        <div
            className={`${styles.header}${props.noHeaderShadow ? ` ${styles.headerNoShadow}` : ''}`}
            style={props.noHeaderShadow ? { boxShadow: 'none' } : undefined}
        >
            {
                mobile ?
                    <div>
                        <img src={LogoSmall} className={styles.logoSmall} alt="Usalco" />
                    </div>
                    :
                    <div>
                        <img src={Logo} className={styles.logo} alt="Usalco" />
                    </div>
            }

            <div className={styles.pageTitle}>{props.pageName}</div>

            {mobile ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginRight: '8px' }}>
                    {readmeTabs.length ? (
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={openReadme}
                            startIcon={<HelpOutlineIcon />}
                        >
                            Help
                        </Button>
                    ) : null}
                </div>
            ) : (
                <div>
                <Box flexGrow={1}
                     component={Stack}
                     direction="column"
                     justifyContent="center"
                     display={'flex'}>
                    <Box align='right'>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end' }}>
                            {readmeTabs.length ? (
                                <Button variant="outlined" size="small" onClick={openReadme} startIcon={<HelpOutlineIcon />}>
                                    Help
                                </Button>
                            ) : null}
                            <Box onClick={handleClick}>
                                <form onSubmit={searchSubmit}>
                                <Search>
                                    <SearchIconWrapper>
                                        <SearchIcon/>
                                    </SearchIconWrapper>
                                    <StyledInputBase placeholder="Search..." inputProps={{'aria-label': 'search'}} onChange={onSearchChange} value={searchTerm} />
                                </Search>
                                </form>
                            </Box>
                        </div>
                    </Box>
                </Box>
                </div>
            )}
            <button
                type="button"
                onClick={menuIconClicked}
                className={`${styles.navToggle}${sidebarOpen ? ` ${styles.navToggleOpen}` : ''}`}
                aria-expanded={sidebarOpen}
                aria-controls="app-navigation"
                aria-label={sidebarOpen ? 'Close navigation' : 'Open navigation'}
            >
                <span className={styles.navToggleIcon} aria-hidden="true" />
            </button>

        </div>

        <div className={styles.contentArea}>
            <div className={styles.maincontent}>{props.children}</div>

            {aiEnabled && chatSession ? (
                <Drawer
                    variant="persistent"
                    anchor={mobile ? "bottom" : "right"}
                    open={chatSession.open}
                    PaperProps={{
                        sx: {
                            width: mobile ? '100%' : chatWidth,
                            maxWidth: '100%',
                            height: mobile ? '75vh' : 'calc(100% - var(--app-header-height))',
                            top: mobile ? 'auto' : 'var(--app-header-height)',
                            overflow: 'visible',
                        }
                    }}
                >
                    <div
                        onMouseDown={(e) => { isResizingChat.current = true; e.preventDefault(); }}
                        style={{
                            position: 'absolute',
                            left: -3,
                            top: 0,
                            bottom: 0,
                            width: 6,
                            cursor: 'col-resize',
                            zIndex: 1,
                            borderRadius: 3,
                            transition: 'background 150ms ease',
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(38,42,86,0.15)'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                    />
                    <div style={{ overflow: 'hidden', height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <ChatPanel />
                    </div>
                </Drawer>
            ) : null}

            <Drawer className={styles.sideDrawer}
                    variant="persistent"
                    anchor={mobile ? "top" : "right"}
                    open={sidebarOpen}>
                <div style={{display:'grid', gridTemplateRows:'1fr auto', height:'100%'}}>
                    <div>
                        <div className={styles.navProfile}>
                            <div className={styles.navProfileAvatar}>
                                {userContext.photo !== 'none' ?
                                    <img src={userContext.photo} alt={userContext.displayName} /> :
                                    <span>{(userContext.displayName || 'User').split(' ').filter(Boolean).slice(0, 2).map((part) => part[0]?.toUpperCase()).join('')}</span>}
                            </div>
                            <div className={styles.navProfileInfo}>
                                <div className={styles.navProfileName}>{userContext.displayName}</div>
                                {userContext.jobTitle ? <div className={styles.navProfileMeta}>{userContext.jobTitle}</div> : null}
                                <button type="button" className={styles.navProfileSignout} onClick={signOut}>Sign out</button>
                            </div>
                        </div>
                        <NavList definition={userContext.navigation} level={1} securities={userContext.securities} isMobile={mobile} />

                    </div>
                    <div className={styles.navExternal}>
                        <div className={styles.navExternalTitle}>External Systems</div>
                        <div className={styles.navExternalGrid}>
                            <a href='http://ross.usalco.com/IAF/IAFWEBDESKTOP_930/' target='_blank' rel="noreferrer" className={styles.navTile}>
                                <div className={styles.navTileIcon}>
                                    <img className={styles.navTileIconImageBase} src={RossLogoPurple} alt="" />
                                    <img className={styles.navTileIconImageHover} src={RossLogo} alt="" />
                                </div>
                                <div className={styles.navTileLabel}>Ross</div>
                            </a>
                            <a href='https://helpdesk.usalco.com' target='_blank' rel="noreferrer" className={styles.navTile}>
                                <div className={styles.navTileIcon}>
                                    <img className={styles.navTileIconImageBase} src={HelpIconPurple} alt="" />
                                    <img className={styles.navTileIconImageHover} src={HelpIcon} alt="" />
                                </div>
                                <div className={styles.navTileLabel}>IT Helpdesk</div>
                            </a>
                            <a href='https://usalco365.sharepoint.com/sites/DocumentControl/SitePages/Home.aspx' target='_blank' rel="noreferrer" className={styles.navTile}>
                                <div className={styles.navTileIcon}>
                                    <img className={styles.navTileIconImageBase} src={SharepointPurple} alt="" />
                                    <img className={styles.navTileIconImageHover} src={Sharepoint} alt="" />
                                </div>
                                <div className={styles.navTileLabel}>Document Control</div>
                            </a>
                            <a href='http://ross-test.usalco.com/IAF/IAFWEBDESKTOP_930/' target='_blank' rel="noreferrer" className={styles.navTile}>
                                <div className={styles.navTileIcon}>
                                    <img className={styles.navTileIconImageBase} src={RossPlayLogoPurple} alt="" />
                                    <img className={styles.navTileIconImageHover} src={RossPlayLogo} alt="" />
                                </div>
                                <div className={styles.navTileLabel}>Ross Playground</div>
                            </a>
                        </div>
                    </div>
                </div>
            </Drawer>


            <Drawer className={styles.searchDrawer}
                    variant="persistent"
                    anchor={mobile ? "top" : "right"}
                    transitionDuration={300}
                    SlideProps={{direction:'down'}}
                    open={openPopper}>
                <div>
                    <Box>
                            <div className={styles.searchPanelTitle}>
                            <div className={styles.searchPanelTitleLeft}>Usalco Search</div>
                            <div className={styles.searchPanelTitleRight}>{searchResults.searchTerm}</div>
                            <div className={styles.searchPanelTitleClose} onClick={handleCloseSearch}>X</div>
                        </div>
                        <div>Type in your search criteria and hit enter. Check back later for more search functionality.</div>
                        <br />
                        { /*
                        <HorizontalScroll>
                        <div className={styles.resultCategories}>
                            <div><span>Products</span></div>
                            <div><span>Reservoir Reports</span></div>
                            <div><span>Orders</span></div>
                        </div>
                        </HorizontalScroll>
                        */
                         }

                        <div className={styles.resultCategoryTitle}>Products</div>
                        {
                            searchResults.parts?.map((result) => {
                                return (
                                    <div key={'part'+result['name']} className={styles.searchResult}>
                                        <div className={styles.searchResultTitle} style={{display:'flex'}}>
                                            <div style={{minWidth:'100px', marginRight:'20px'}}>
                                                <div style={{fontWeight:'bold', fontSize:'12px'}}>Ross Part</div>
                                                <div>{result['PART_CODE']}</div>
                                            </div>
                                            <div>
                                                <div style={{fontWeight:'bold', fontSize:'12px'}}>FRQ Part</div>
                                                <div>{(result['SYS_USER_DEFINED_1']==='' ? <i style={{fontSize:'15px'}}>(none)</i> : result['SYS_USER_DEFINED_1'])}</div>
                                            </div>
                                        </div>
                                        { /*
                                        <div>
                                            <div
                                                onClick={(e) => {
                                                    navigate('/report2/D85B4CC7-AF48-45A9-869B-D720E50E8106',
                                                             {
                                                                 state: {
                                                                     addFilters:[
                                                                         {
                                                                             id: 'f328jfdsk3',
                                                                             field: {
                                                                                 Name: "Product Code",
                                                                                 Type: "string"
                                                                             },
                                                                             comparison: 'eq',
                                                                             value: ['z9',null]
                                                                         }
                                                                     ]
                                                                 }
                                                             }
                                                    )
                                                }}>Open Orders
                                            </div>
                                        </div>
                                        */ }
                                    </div>
                                );
                            })
                        }

                        <div className={styles.resultCategoryTitle} style={{opacity: '38%'}}>Reservoir Reports</div>
                        <div className={styles.resultCategoryTitle} style={{opacity: '38%'}}>Orders</div>
                        <div className={styles.resultCategoryTitle} style={{opacity: '38%'}}>Customers</div>
                    </Box>
                </div>
            </Drawer>

            {readmeTabs.length ? (
                <Dialog
                    open={readmeOpen}
                    onClose={closeReadme}
                    fullWidth
                    maxWidth="md"
                    sx={{
                        '& .MuiDialog-container': {
                            alignItems: 'flex-start',
                            paddingTop: '60px'
                        }
                    }}
                >
                    <DialogTitle>{props.readmeTitle || "Help"}</DialogTitle>
                    {readmeTabs.length > 1 ? (
                        <Tabs
                            value={readmeTabIndex}
                            onChange={handleReadmeTabChange}
                            variant="scrollable"
                            allowScrollButtonsMobile
                            sx={{ paddingX: "16px", borderBottom: "1px solid #e0e0e0" }}
                        >
                            {readmeTabs.map((tab, idx) => (
                                <Tab
                                    key={`${tab.title || "readme"}-${idx}`}
                                    label={tab.title || "Help"}
                                    sx={idx === rightAlignedReadmeIndex ? { marginLeft: "auto" } : undefined}
                                />
                            ))}
                        </Tabs>
                    ) : null}
                    <DialogContent sx={{ overflowY: "hidden" }}>
                        {activeReadmeLoading ? (
                            <div style={{ textAlign: "center", padding: "24px 0" }}>
                                <CircularProgress />
                            </div>
                        ) : activeReadmeError ? (
                            <Typography style={{ color: "#b00020" }}>{activeReadmeError}</Typography>
                        ) : (
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: !mobile && readmeTocItems.length ? "220px 1fr" : "1fr",
                                    gridTemplateRows: mobile && readmeTocItems.length ? "auto 1fr" : "1fr",
                                    gap: "16px",
                                    maxHeight: mobile ? "60vh" : "65vh",
                                    overflow: "hidden",
                                }}
                            >
                                {readmeTocItems.length ? (
                                    <div
                                        style={{
                                            borderRight: mobile ? "none" : "1px solid #e0e0e0",
                                            paddingRight: mobile ? "0" : "12px",
                                            overflowY: "auto",
                                            maxHeight: mobile ? "160px" : "65vh",
                                        }}
                                    >
                                        <div style={{ fontWeight: 600, marginBottom: "8px" }}>Outline</div>
                                        {readmeTocItems.map((item) => (
                                            <Button
                                                key={item.slug}
                                                variant="text"
                                                size="small"
                                                onClick={() => {
                                                    const el = document.getElementById(item.slug);
                                                    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                                                }}
                                                style={{
                                                    justifyContent: "flex-start",
                                                    textTransform: "none",
                                                    width: "100%",
                                                    paddingLeft: `${Math.max(item.level - 1, 0) * 12}px`,
                                                }}
                                            >
                                                {item.text}
                                            </Button>
                                        ))}
                                    </div>
                                ) : null}
                                <div style={{ fontSize: "14px", lineHeight: 1.6, overflowY: "auto", maxHeight: mobile ? "60vh" : "65vh" }}>
                                    <ReactMarkdown components={readmeComponents}>{activeReadmeText}</ReactMarkdown>
                                </div>
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <div style={{ marginRight: "auto", fontSize: "12px", color: "#666" }}>
                            For further assistance with questions or issues contact{" "}
                            <a href="mailto:help@usalco.com">help@usalco.com</a>.
                        </div>
                        <Button onClick={closeReadme}>Close</Button>
                    </DialogActions>
                </Dialog>
            ) : null}

        </div>
    </div>);
}
